export const MediaGalleryFilter = {
    init() {
        var $menu = $('.media-filter'),
            $leftBlock = $('.left-block'),
            $rightBlock = $('.right-block'),
            $leftNav = $('.media-filter-nav-left'),
            $rightNav = $('.media-filter-nav-right'),
            maxScrollLeft = 0;

        function updateScrollBlocks() {
            maxScrollLeft = $menu[0].scrollWidth - $menu[0].clientWidth;

            if ($menu.scrollLeft() === 0) {
                $leftBlock.addClass('hide');
                $leftNav.addClass('hidden');
            } else {
                $leftBlock.removeClass('hide');
                $leftNav.removeClass('hidden');
            }

            if ($menu.scrollLeft() >= maxScrollLeft) {
                $rightBlock.addClass('hide');
                $rightNav.addClass('hidden');
            } else {
                $rightBlock.removeClass('hide');
                $rightNav.removeClass('hidden');
            }
        }

        $rightNav.on('click', () => {
            if ($menu.scrollLeft() >= maxScrollLeft) return;
            $menu.animate(
                {
                    scrollLeft: '+=140px',
                },
                'slow'
            );
        });

        $leftNav.on('click', () => {
            if ($menu.scrollLeft() == 0) return;
            $menu.animate(
                {
                    scrollLeft: '-=140px',
                },
                'slow'
            );
        });

        // On scroll, check scroll position
        $menu.on('scroll', updateScrollBlocks);

        // Initial check
        updateScrollBlocks();

        $(window).resize(function () {
            updateScrollBlocks();
        });
    },
};
